import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import BranchesPage from "@/pages/BranchesPage";
import SummerSchoolPage from "@/pages/SummerSchoolPage";
import FacilitiesPage from "@/pages/FacilitiesPage";
import ContactPage from "@/pages/ContactPage";
import PreRegistrationPage from "@/pages/PreRegistrationPage";
import VolleyballPage from "@/pages/VolleyballPage";
import BasketballPage from "@/pages/BasketballPage";
import GymnasticsPage from "@/pages/GymnasticsPage";
import AdminPage from "@/pages/AdminPage";
import CoachesPage from "@/pages/CoachesPage";
import TrialRegistrationPage from "@/pages/TrialRegistrationPage";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/branslarimiz" element={<BranchesPage />} />
          <Route path="/branslarimiz/voleybol" element={<VolleyballPage />} />
          <Route path="/branslarimiz/basketbol" element={<BasketballPage />} />
          <Route path="/branslarimiz/cimnastik" element={<GymnasticsPage />} />
          <Route path="/yonetim" element={<AdminPage />} />
          <Route path="/antrenorler" element={<CoachesPage />} />
          <Route path="/deneme-antrenman" element={<TrialRegistrationPage />} />
          <Route path="/yaz-spor-okulu" element={<SummerSchoolPage />} />
          <Route path="/tesisler" element={<FacilitiesPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/on-kayit" element={<PreRegistrationPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
